import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myfilter',
    pure: false
})
export class MyFilterPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        let propertyName = null;
        if (!items || !filter) {
            return items;
        }
        for (const property of Object.getOwnPropertyNames(items[0])) {
            if(property == 'name'){
                propertyName = property;
            }
        }
        if(propertyName != null){
            return items.filter(item => item[propertyName].indexOf(filter) !== -1);
        }
        return items.filter(item => item.dbName.indexOf(filter) !== -1);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipes/filter-pipe.ts